<template lang="pug">
  .component-commont-cost-type-action-buttons
    ModalReveal
      button.button.warning(slot="trigger", type="button") Edit
      .row
        .columns
          label Name
            input(type="text", v-model="item.name")
          label Description
            input(type="text", v-model="item.description")
      .row.columns.text-center
        button.button(@click="edit") Save
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from 'src/maggieHelper'
  import ModalReveal from '../../foundation/ModalReveal'


export default {
    name: "TocButtons",
    components: {
      ModalReveal
    },
    data() {
      return {
      }
    },
    created() {
    },
    methods: {
      edit() {
        KeplerBackofficeSdk.commonCostType.edit(this.item, () => {
          this.$emit('itemUpdated')
        })
      }
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CommonCostTypeButton.vue?56e85f1c